import { render, staticRenderFns } from "./TaskMoneyConfigxdsj.vue?vue&type=template&id=0be45d24&"
import script from "./TaskMoneyConfigxdsj.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigxdsj.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigxdsj.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports